import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, finalize, throwError } from 'rxjs';
import { RequestsStatusState } from '../requests-status.service';
import { RequestsStatusEnum } from '../models/requests-status.enum';
import { UrlPathsEnum } from '../models/url-paths-enum';
import { some } from 'lodash';

@Injectable()
export class RequestsStatusInterceptorService implements HttpInterceptor {
	public constructor(private requestsStatusState: RequestsStatusState) {}

	public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const shouldSetStatusForRequest: boolean = some(
			[
				UrlPathsEnum.copyin,
				UrlPathsEnum.checkin,
				UrlPathsEnum.checkout,
				UrlPathsEnum.import,
				UrlPathsEnum.export
			],
			(item: string) => request.url.includes(item)
		);

		return next.handle(request).pipe(
			() => {
				if (shouldSetStatusForRequest && request?.body?.RecordId) {
					this.requestsStatusState.set(request.body?.RecordId, RequestsStatusEnum.Pending);
				}
				return next.handle(request);
			},
			catchError((err) => {
				if (shouldSetStatusForRequest && request?.body?.RecordId) {
					this.requestsStatusState.set(request.body?.RecordId, RequestsStatusEnum.Error);
				}
				return throwError(() => err);
			}),
			finalize(() => this.requestsStatusState.remove(request?.body?.RecordId))
		);
	}
}
